import { ref } from 'vue'

export const useFeedback = () => {
  const isVisible = ref(false)
  const message = ref('')

  const hide = () => {
    isVisible.value = false
  }

  const show = text => {
    message.value = text
    isVisible.value = true
  }

  // 通知が描画された時点から3秒後に閉じる。
  const startAutoHide = () => {
    setTimeout(hide, 3000)
  }

  return { isVisible, message, show, hide, startAutoHide }
}
